
import { DandDFeatureSource } from "@dndModels/feature_sources/SystemFeatureSource";
import { 
  FeatureBase,
  // Limitation 
} from "@models";
import { 
  ASIBaseFeature,
  Feat,
  FeatFeature,
  StartEquipmentChoice, 
} from "@dndModels";
import CommonUtilities from "@utilities/common_utilities";
import { AbilityScoreExpandedType, DataType } from "@dndModels/Types";

const common_util = CommonUtilities.getInstance();

export class Background extends DandDFeatureSource {
  data_type: DataType = "background";
  feature_source_type = "Background";
  old_start_equipment: StartEquipmentChoice[] = [];
  feats: Feat[] = [];

  constructor(obj?: any) {
    super(obj, "Background");
    if (obj) {
      if (obj.the_feature) {
        if (obj.the_feature.start_equipment) {
          for (const o of obj.the_feature.start_equipment) {
            const choice = new StartEquipmentChoice(o);
            this.old_start_equipment.push(choice);
          }
        }
        if (this.feature_bases.length === 0 && obj.the_feature.features && obj.the_feature.features.length > 0) {
          for (const o of obj.the_feature.features) {
            o.source_id = this._id;
            o.source_type = this.feature_source_type;
            const feature_base = new FeatureBase(o);
            this.feature_bases.push(feature_base);
          }
        }
      } else {
        if (obj.start_equipment) {
          for (const o of obj.start_equipment) {
            const choice = new StartEquipmentChoice(o);
            this.old_start_equipment.push(choice);
          }
        }
        if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
          for (const o of obj.features) {
            o.source_id = this._id;
            o.source_type = this.feature_source_type;
            const feature_base = new FeatureBase(o);
            this.feature_bases.push(feature_base);
          }
        }
      }
      // console.log(obj);
      this._feat_ids = obj._feat_ids ? obj._feat_ids : [];
      this._ability_scores = obj._ability_scores ? obj._ability_scores : [];
    }
  }

  _feat_ids: string[] = [];
  get feat_ids() {
    if (this.loaded) {
      const feat_fb = this.feature_bases.find(o => o.features.filter(o2 => o2.feature_type === "Feat").length > 0);
      if (feat_fb) {
        const f = feat_fb.features.find(o => o.feature_type === "Feat");
        if (f && f.floating_feature instanceof FeatFeature) {
          const ff = f.floating_feature;
          return ff.feat_ids;
        }
      }
      return [];
    } else {
      return this._feat_ids;
    }
  }

  get feat_names() {
    return this.feats.map(o => o.name).join(", ");
  }

  _ability_scores: AbilityScoreExpandedType[] = [];
  get ability_scores() {
    // if (this.name.includes("House")) {
    //   console.log(this.feature_bases.find(o => o.features.filter(o2 => o2.floating_feature instanceof ASIBaseFeature && o2.floating_feature.choices.filter(o3 => o3.asi_features.filter(o4 => o4.amount > 0).length > 0).length > 0).length > 0));
    // }
    if (this.loaded) {
      const asi_fb = this.feature_bases.find(o => o.features.filter(o2 => o2.floating_feature instanceof ASIBaseFeature && o2.floating_feature.choices.filter(o3 => o3.asi_features.filter(o4 => o4.amount > 0).length > 0).length > 0).length > 0);
      if (asi_fb) {
        const f = asi_fb.features.find(o2 => o2.floating_feature instanceof ASIBaseFeature && o2.floating_feature.choices.filter(o3 => o3.asi_features.filter(o4 => o4.amount > 0).length > 0).length > 0);
        if (f && f.floating_feature instanceof ASIBaseFeature) {
          const ff = f.floating_feature;
          const choice = ff.choices[0];
          const asis = common_util.unique_array(choice.asi_features.flatMap(o => o.options));
          return asis;
        }
      }
      return [];
    } else {
      return this._ability_scores;
    }
  }

  get asi_string() {
    return this.ability_scores.join(", ");
  }

  get_detail_format() {
    let str = super.get_detail_format();
    // if (this.name.includes("Astral")) {
    //   debugger;
    // }
    if ((this.feat_ids.length > 0 && !this.feat_ids.includes("Any")) || this.asi_string.trim().length > 0) {
      str += ";"; 
      if (this.feat_ids.length > 0 && !this.feat_ids.includes("Any")) {
        str += ` {list_of_type:feat;${this.feat_ids}}`;
      }
      if (this.asi_string.length > 0) {
        str += ` ${this.asi_string}`;
      }
    }
    return str.trim();
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      _feat_ids: this.feat_ids,
      _ability_scores: this.ability_scores,
    };
  }

  toLight(): any {
    const feature_source_obj = super.toLight();
    return {
      ...feature_source_obj,
      _feat_ids: this.feat_ids,
      _ability_scores: this.ability_scores,
    };
  }

  clone(drop_ids = false): Background {
    const new_obj = new Background();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy(copyMe: Background, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    // this._id = copyMe._id;
    // this.name = copyMe.name;
    // this.description = copyMe.description;
    // this.feature_bases = [...copyMe.feature_bases];
    this.old_start_equipment = [];
    copyMe.old_start_equipment.forEach(se => {
      this.old_start_equipment.push(se.clone(drop_ids));
    });
  }

  copy5e(copyMe: any) {
    console.log(copyMe);
  }
}